import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from '../user/auth.service';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UiInteractionService {
  // Subject to request opening the sign-in dialog
  readonly requestSignInDialog$ = new Subject<void>();

  constructor(private authService: AuthService) {}

  /**
   * Call this method from any component to request that the main
   * sign-in dialog (likely hosted in HeaderComponent) be opened.
   */
  openSignInDialog(): void {
    this.authService.currentUser$.pipe(take(1)).subscribe(user => {
      if (!user) {
        this.requestSignInDialog$.next();
      }
    });
  }
}
